var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:'button--'+_vm.config.class,on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('b-icon-calendar-check-fill'),_vm._v(" "+_vm._s(_vm.config.text)+" "),_c('div',{staticClass:"point"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }